require('../datepicker/datepicker.css');
require('../position/position.css');
require('./popup.css');
module.exports = require('./index-nocss.js');



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/angular-ui-bootstrap/src/datepickerPopup/index.js